import React, { useReducer } from 'react';
import CitasReducer from './citasReducer';
import CitasContext from './citasContext';
import clienteAxios from '../../config/axios';
import swal from 'sweetalert2';

import {
    INIT_REGISTRO_CITA,  
    REGISTRO_CITA_EXITOSO,
    REGISTRO_CITA_ERROR,
    OBTENER_SUCURSALES_SUCCESS,
    OBTENER_SUCURSALES_ERROR,
    OBTENER_ESTUDIOS_SUCCESS,
    OBTENER_ESTUDIOS_ERROR,
    OBTENER_CITAS,      
    OBTENER_CITAS_EXITOSO,
    OBTENER_CITAS_ERROR 
} from '../../types';

const CitasState = ( props ) => {

    const inicialState = {
        citas: null,
        cargando: false,
        error: null,
        requests: 0,
        sucursales: [],
        estudios: []
    }

    const [ state, dispatch ] = useReducer( CitasReducer, inicialState );

    const obtenerSucursales = async ( data ) => {
        
        try {
            const respuesta = await clienteAxios.get( `/citas/sucursales/${data}` );
            
            if( respuesta.data ){
                dispatch( obtenerSucursalesExitoso( respuesta.data ) );
            }else{
                dispatch( obtenerSucursalesExitoso( null ) );
            }
            return respuesta.data;
        } catch (error) {
            console.log( error );
            dispatch( obtenerSucursalesError( error ) );
        }
    }

    const obtenerEstudios = async ( data ) => {
        
        try {
            const respuesta = await clienteAxios.get( `/citas/estudios/${data}` );
            
            if( respuesta.data ){
                dispatch( obtenerEstudiosExitoso( respuesta.data ) );
            }else{
                dispatch( obtenerEstudiosExitoso( null ) );
            }
            return respuesta.data;
        } catch (error) {
            console.log( error );
            dispatch( obtenerEstudiosError( error ) );
        }
    }

    const obtenerCitas = async ( data ) => {
        dispatch( initObtenerCitas() );
        
        try {
            const respuesta = await clienteAxios.get( `/citas/${data}` );
            
            if( respuesta.data ){
                dispatch( obtenerCitasExitoso( respuesta.data ) );
            }else{
                dispatch( obtenerCitasExitoso( null ) );
            }
        } catch ( error ) {
            console.log( error );
            dispatch( obtenerCitasError( error ) );
        }
    }

    const guardarCita = async ( data ) => {
        dispatch( initRegistroCita() );

        try {
            const response = await clienteAxios.post( '/citas/', data );
            
            if( response.data ){
                dispatch( registroCitaExitoso( response.data ) );
                swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Su cita ha sido programada correctamente',
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                dispatch( registroCitaExitoso( null ) );
                swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'La cita no pudo ser programada!',
                });
            }
        } catch ( error ) {
            console.log( error );
            dispatch( registroCitaError( error ) );
            swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al programar la cita. Favor de contactar su clínica',
            });
        }
    }



    const initRegistroCita = () => ( { type: INIT_REGISTRO_CITA } );

    const registroCitaExitoso = ( data ) => ( { type: REGISTRO_CITA_EXITOSO, payload: data } );

    const registroCitaError = ( error ) => ( { type: REGISTRO_CITA_ERROR, payload: error } );

    const initObtenerCitas = () => ( { type: OBTENER_CITAS } );

    const obtenerCitasExitoso = ( data ) => ( { type: OBTENER_CITAS_EXITOSO, payload: data } );

    const obtenerCitasError = ( error ) => ( { type: OBTENER_CITAS_ERROR, payload: error } );

    const obtenerSucursalesExitoso = ( data ) => ( { type: OBTENER_SUCURSALES_SUCCESS, payload: data } );

    const obtenerSucursalesError = ( error ) => ( { type: OBTENER_SUCURSALES_ERROR, payload: error } );

    const obtenerEstudiosExitoso = ( data ) => ( { type: OBTENER_ESTUDIOS_SUCCESS, payload: data } );

    const obtenerEstudiosError = ( error ) => ( { type: OBTENER_ESTUDIOS_ERROR, payload: error } );

    return ( 
        <CitasContext.Provider
            value={{
                citas: state.citas,
                sucursales: state.sucursales,
                estudios: state.estudios,
                obtenerSucursales,
                obtenerEstudios,
                guardarCita,
                obtenerCitas
            }}
        >
            {props.children}
        </CitasContext.Provider>
     );
}
 
export default CitasState;